import React, { useState, useEffect } from 'react';

interface Message {
  id: number;
  author: string;
  text: string;
  timestamp: Date;
}

const YouTubeLiveStreamPage: React.FC = () => {
  const [isLiked, setIsLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(1243);
  
  // Get stream ID from URL query parameters
  const [youtubeVideoId, setYoutubeVideoId] = useState('BOkqiNYhJL0'); // Default: lofi hip hop radio
  
  useEffect(() => {
    // Parse URL to get stream ID
    const queryParams = new URLSearchParams(window.location.search);
    const streamId = queryParams.get('id');
    
    // If stream ID is provided in URL, use it
    if (streamId) {
      setYoutubeVideoId(streamId);
    }
  }, []);
  
  const handleLikeToggle = () => {
    setIsLiked(!isLiked);
    setLikeCount(prev => isLiked ? prev - 1 : prev + 1);
  };
  
  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <div className="container mx-auto p-2 sm:p-4">
        {/* Header - Responsive for mobile */}
        <header className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 gap-2">
          <div className="flex items-center">
            <div className="text-red-600 text-xl sm:text-2xl font-bold mr-2">NAE COACHING</div>
            <span className="text-gray-400 bg-red-700 rounded-full px-2 text-sm">Live</span>
          </div>
          <div className="flex flex-wrap gap-2 sm:space-x-4">
            <button className="bg-gray-700 hover:bg-gray-600 px-3 py-1 rounded-2xl text-sm">
              Subscribe
            </button>
            <div className="text-gray-400 text-sm">
              Online users: 2,457
            </div>
          </div>
        </header>
        
        <div className="flex flex-col lg:flex-row gap-4">
          {/* Video Player Section */}
          <div className="w-full lg:w-2/3">
            <div className="relative pt-[56.25%] bg-black rounded-lg overflow-hidden">
              <iframe 
                className="absolute inset-0 w-full h-full"
                src={`https://www.youtube.com/embed/${youtubeVideoId}?autoplay=1&live=1&enablejsapi=1`}
                title="YouTube Live Stream"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            
            <div className="mt-4">
              <h1 className="text-lg sm:text-xl font-bold">Live Stream Title: Relaxing Music for Work, Study and Focus</h1>
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mt-2 gap-2">
                <div className="flex items-center space-x-2">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 bg-blue-500 rounded-full flex items-center justify-center">
                    <span className="font-bold text-sm sm:text-base">NAE</span>
                  </div>
                  <div>
                    <p className="font-semibold text-sm sm:text-base">NAE COACHING</p>
                    <p className="text-gray-400 text-xs sm:text-sm">1.2M subscribers</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-4 mt-2 sm:mt-0">
                  <button 
                    onClick={handleLikeToggle}
                    className={`flex items-center space-x-1 ${isLiked ? 'text-blue-500' : 'text-gray-400'}`}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 sm:h-6 sm:w-6" fill={isLiked ? "currentColor" : "none"} viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
                    </svg>
                    <span className="text-sm sm:text-base">{likeCount}</span>
                  </button>
                  
                  <button className="flex items-center space-x-1 text-gray-400">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 sm:h-6 sm:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 11v8a1 1 0 01-1 1h-2a1 1 0 01-1-1v-8m5 0h12m-12 0v-4a1 1 0 011-1h.564a2 2 0 011.789 2.894l-.789 1.106m-1 0h-1a1 1 0 01-1-1v-4a1 1 0 011-1h.586a2 2 0 011.789 2.894l-.789 1.106" />
                    </svg>
                    <span className="text-sm sm:text-base">Dislike</span>
                  </button>
                  
                  <button className="flex items-center space-x-1 text-gray-400">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 sm:h-6 sm:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
                    </svg>
                    <span className="text-sm sm:text-base">Share</span>
                  </button>
                </div>
              </div>
              
              <div className="mt-4 bg-gray-800 p-3 sm:p-4 rounded-lg text-sm sm:text-base">
                <p className="text-gray-300">
                  📢 Welcome to our live stream! Enjoy relaxing background music perfect for studying, working, or just unwinding. Don't forget to like and subscribe for more content like this.
                </p>
              </div>
            </div>
          </div>
          
          {/* Chat Section - Always visible and using authenticated YouTube chat */}
          <div className="w-full lg:w-1/3 mt-4 lg:mt-0">
            <div className="bg-gray-800 rounded-lg h-full flex flex-col">
              <div className="p-2 sm:p-3 border-b border-gray-700 flex justify-between items-center">
                <h2 className="font-semibold text-sm sm:text-base">Live Chat</h2>
                <div className="text-xs sm:text-sm text-gray-400">NAE COACHING Chat</div>
              </div>
              
              {/* YouTube's native chat iframe with auth parameter */}
              <div className="flex-grow relative" style={{ height: '500px' }}>
                <iframe
                  src={`https://www.youtube.com/live_chat?v=${youtubeVideoId}&embed_domain=${window.location.hostname}&parent=${window.location.hostname}&auth=1`}
                  className="w-full h-full"
                  frameBorder="0"
                ></iframe>
              </div>
              
              {/* Chat info - optional section to provide info about YouTube chat */}
              <div className="p-2 border-t border-gray-700 text-xs text-gray-400">
                <p>Chat requires a YouTube account. Chat messages will appear on both this page and YouTube.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YouTubeLiveStreamPage;